var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-navigation-onboarding"},[_c('div',{staticClass:"search-navigation-onboarding__frame"}),_c('div',{directives:[{name:"t",rawName:"v-t",value:('startObserving'),expression:"'startObserving'"}],staticClass:"search-navigation-onboarding__balloon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }